import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";

export const SMSPlus: FC<IconProps> = ({
  color = defaultColor,
  height = 21.5,
}) => (
  <svg
    width="23.5"
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23.5 21.5"
  >
    <title>Asset 1</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Frames-24px">
          <polyline
            fill={color}
            stroke="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="20.5 8 20.5 17 8.5 17 4.5 21 4.5 17 0.5 17 0.5 3 15 3"
          />
          <line
            fill={color}
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            x1="18"
            y1="3"
            x2="23"
            y2="3"
          />
          <line
            fill={color}
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            x1="20.5"
            y1="5.5"
            x2="20.5"
            y2="0.5"
          />
        </g>
      </g>
    </g>
  </svg>
);
